import AppConfig from '../common/AppConfig';
import './EnvironmentBanner.css';

const bannerConfig = {
    Local:      { label: 'Local Environment',      className: 'env-banner env-banner--local' },
    QA:      { label: 'QA Environment',      className: 'env-banner env-banner--qa' },
    PreProd: { label: 'Pre-Production Environment', className: 'env-banner env-banner--preprod' },
};

const EnvironmentBanner = () => {
  const config = bannerConfig[AppConfig.environment];
  if (!config) return null;

  return (
    <div className={config.className}>
      {config.label}
    </div>
  );
};

export default EnvironmentBanner;
